import React from 'react';
import s from './HotCard.scss';
// import { shortLargeInt } from '../../../utils';
import { LinkWrapper } from '../../../components/BaseComp';
import { FeedInstance } from '../../../models/feed';

interface Props {
    title: string,
    dataSource: FeedInstance[]
}

const CommentItem = ({ item }: { item: FeedInstance }) => {
    return (
        <div className={s.item} data-spm-type="resource">
            <LinkWrapper
                data-spm-type="content"
                href={item.url ? item.url : `/a/${item.id}_${item.authorId}`}
                className={s.feedTitle}
            >
                <p>{item.title}</p>
            </LinkWrapper>
            {/* <LinkWrapper
                href={item.url ? `${item.url}#mpbox` : `/a/${item.id}_${item.authorId}#mpbox`}
                className={s.count}
            >
                <p className={s.counts}>{shortLargeInt(item.cmt || 0)}</p>
                <p className={s.countLabel}>评论</p>
            </LinkWrapper> */}
        </div>
    );
};

const CommentImage = ({ item } : { item: FeedInstance }) => {
    const cover = (item.bigCover || (item.images && item.images[0]) || '').replace(/w_([\s\S]+?),/g, 'w_520,').replace(/h_([\s\S]+?),/g, 'h_260,');
    return (
        <div className={s.imageFeed}>
            <img src={cover} alt={item.title} className={s.image}/>
            <LinkWrapper href={item.url} className={s.titleBox}>
                <p className={s.title}>
                    {item.title}
                </p>
            </LinkWrapper>
            <div className={s.commentBox}>
                <LinkWrapper href={item.personalPage || item.url}>{item.authorName}</LinkWrapper>
                 {/* · <LinkWrapper href={`${item.url}#mpbox`}> {item.cmt || 0} 评论</LinkWrapper> */}
            </div>
        </div>
    );
};

export const HotCardComment = (props: Props) => {
    const { title, dataSource } = props;

    const data = dataSource.slice(0, 10);

    return (
        <div className={s.cardContainer}>
            <h3 className={s.title}>{title}</h3>
            <ul data-spm="top-hotcomments">
                {
                    data.map((a, index) => {
                        if (index === 0) {
                            return <CommentImage key={index} item={a} />;
                        }
                        return <CommentItem item={a} key={index} />;
                    })
                }
            </ul>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/HotCard/HotCard.comment.tsx